import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useParams } from 'react-router-dom';

import Theme from '../components/theme';
import { Spinner } from '../components/spinner';
import { TimersProvider } from '../contexts/timer';
import { GameStateProvider } from '../contexts/game';
import { PlayerStateProvider } from '../contexts/player';
import { GameDocumentProvider } from '../contexts/game-document';
import { DisplayLanguageProvider } from '../contexts/display-languages';
import { ErrorBoundaryFallback } from '../components/error-boundary-fallback';

export const GameLayout = () => {
  const { gameCode } = useParams();

  return (
    <ErrorBoundary
      fallbackRender={(props) => <ErrorBoundaryFallback {...props} />}>
      <Suspense fallback={<Spinner />}>
        <GameDocumentProvider gameCode={gameCode!}>
          <PlayerStateProvider gameCode={gameCode!}>
            <TimersProvider gameCode={gameCode!}>
              <GameStateProvider gameCode={gameCode!}>
                <DisplayLanguageProvider>
                  <Theme />
                  <Outlet />
                </DisplayLanguageProvider>
              </GameStateProvider>
            </TimersProvider>
          </PlayerStateProvider>
        </GameDocumentProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default GameLayout;
